<div class="container-fluid">
    <div class="row ">
        <div class="col-lg-2">
        </div>
        <div class="col-lg-8 " style="text-align: center;">
            <h4><b>Slow Moving Stock </b></h4>
            <!-- <app-video-widget [videoId]="14" style="float: inline-end;"></app-video-widget> -->

        </div>
        <div class="col-lg-2">
        </div>
    </div>
</div>

<div class="text-center">
    <p style="margin-bottom: 15px;">
        <b>Below you can load slow moving stock, that can be bought at a discounted price.</b>
    </p>

     <div nz-row nzGutter="24">
        <div nz-col [nzSpan]="spanStock">
            <nz-spin [nzSpinning]="isLoadingStock">
                <div nz-row nzJustify="space-around">
                                    <div nz-col nzSpan="6">
                                        <button nz-button nzType="default" (click)="openAdd()">
                                                <i nz-icon nzType="plus" nzTheme="outline"></i>
                                                &nbsp;Add New Stock
                                            </button>
                                    </div>
                                    <div nz-col nzSpan="10">
                                        <nz-input-group [nzSuffix]="suffixIconSearch">
                                            <input type="text" nz-input placeholder="Search Stock" [nzSize]="'large'" [(ngModel)]="input.inputValue" (keyup.enter)="getItems()" style="text-transform:uppercase;" />
                                        </nz-input-group>
                                        <ng-template #suffixIconSearch>
                                            <span nz-icon nzType="search"></span>
                                        </ng-template>
                                    </div>
                                    <div nz-col nzSpan="6">

                                    </div>
                                </div>
                                <br>
                                <nz-table #stockTable [nzData]="stock" [nzFrontPagination]="false" [nzSize]="'small'">
                                    <thead>
                                        <tr>
                                            <th>Brand</th>
                                            <th nzWidth="350px">Description</th>
                                            <th>Stock Code</th>
                                            <th>Price <small class="text-style">*(Vat Excl)</small></th>
                                            <th>SOH</th>                                            
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                            <tr *ngFor="let data of stockTable.data | filter: input.inputValue: input.inputList: 2: pageSize;">
                                                <td class="text-center">
                                                    <img nz-tooltip nzTooltipPlacement="top" [nzTooltipTitle]="data.brand" class="brandImage" src='https://sftptyres.blob.core.windows.net/brands-images/brands/{{data.image}}'>
                                                </td>
                                                <td [ngClass]="{'color-error' :  data.mapped != 1}">{{ data.description.toUpperCase()}}</td>
                                                <td>
                                                    {{ data.code }}
                                                    <span nz-icon nzType="search" nzTheme="outline" *ngIf="data.isSearchable" nz-tooltip nzTooltipTitle="Stock Code Searchable " nzTooltipPlacement="right"></span>
                                                </td>
                                                <td><button nz-button nzType="default"><span class="text-info-style">R </span>{{ data.price| number }}</button></td>
                                                <td><button nz-button nzType="default"><span class="text-info-style"></span>&nbsp;{{ data.soh| number }}</button></td>
                                                <td class="text-center">
                                                    <nz-button-group>
                                                        <button nz-button nzType="primary" data-toggle="modal" data-target="#updatestock" (click)="loadStock(data)">
                                                            <span nz-icon nzType="edit" nzTheme="outline"></span>
                                                        </button>
                                                        <button nz-button nzType="default" nzDanger (click)="removeItem(data)">
                                                            <span nz-icon nzType="delete" nzTheme="outline"></span>
                                                        </button>
                                                    </nz-button-group>
                                                </td>
                                            </tr>
                                        
                                        <tr>
                                            <td colspan="6"></td>
                                        </tr>
                                    </tbody>
                                </nz-table>
            </nz-spin>
        </div>
   
</div>

<div class="container-fluid">
    <div class="row ">
        <div class="col" style="text-align: center;" >
            <h6 style="color: red">{{errorMsg}}</h6>
        </div>
    </div>
</div>

<!--Modal-->

<nz-modal [nzVisible]="isAddStock || isUpdateStock" nzTitle="{{title}}" (nzOnCancel)="closeModal(this.stockForm)" nzWidth="700px">
    <div *nzModalContent>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-8 offset-2">
                    <form nz-form [formGroup]="stockForm">
                        <nz-form-item>
                            <nz-form-label [nzSpan]="24" nzRequired>Description</nz-form-label>
                            <nz-form-control [nzSpan]="24" nzHasFeedback>
                                <nz-input-group nzPrefixIcon="file-text">
                                    <input formControlName="description" name="description" nz-input placeholder="Description" 
                                        nzBorderless [nzAutocomplete]="auto"/>
                                </nz-input-group>
                                <nz-autocomplete #auto >
                                    <nz-auto-option *ngFor="let opt of descriptionOptions" [nzValue]="opt"
                                        style="width: 100%;">
                                        {{ opt }}
                                    </nz-auto-option>
                                </nz-autocomplete>
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item>
                            <nz-form-label [nzSpan]="24" nzRequired>Price</nz-form-label>
                            <nz-form-control [nzSpan]="24" nzHasFeedback>
                                <nz-input-group nzPrefixIcon="money-collect">
                                    <input formControlName="price" name="price" nz-input placeholder="Price" nzBorderless/>
                                </nz-input-group>
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item>
                            <nz-form-label [nzSpan]="24" nzRequired>SOH</nz-form-label>
                            <nz-form-control [nzSpan]="24" nzHasFeedback>
                                <nz-input-group nzPrefixIcon="money-collect">
                                    <input formControlName="soh" name="soh" nz-input placeholder="SOH" nzBorderless/>
                                </nz-input-group>
                            </nz-form-control>
                        </nz-form-item>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div *nzModalFooter>
        <button nz-button nzType="primary" (click)="submit()" [disabled]="!stockForm.valid">
            <i nz-icon nzType="save" nzTheme="fill" style="vertical-align: top; margin-right: 4px; font-size: 1.5rem;"></i>Save
        </button>
    </div>
</nz-modal>
